import styled from 'styled-components'
import { Clock, Check, Package, User, RefreshCcw } from 'lucide-react'
import { STATUS_TYPES } from 'modules/_common/EstablishmentOrderStatusTypes';

export default function EstablishmentOrderStatusChips({ status }) {
    // Status display config
    const STATUS_CONFIG = {
        [STATUS_TYPES.REQUESTED.key]: { label: STATUS_TYPES.REQUESTED.label, color: { bg: '#f3f4f6', text: '#374151' }, icon: Clock },
        [STATUS_TYPES.CONFIRMED.key]: { label: STATUS_TYPES.CONFIRMED.label, color: { bg: '#dbeafe', text: '#1e40af' }, icon: Check },
        [STATUS_TYPES.PREPARING.key]: { label: STATUS_TYPES.PREPARING.label, color: { bg: '#fef3c7', text: '#92400e' }, icon: Package },
        [STATUS_TYPES.READY_FOR_PICKUP.key]: { label: STATUS_TYPES.READY_FOR_PICKUP.label, color: { bg: '#dcfce7', text: '#166534' }, icon: Package },
        [STATUS_TYPES.PICKED_UP.key]: { label: STATUS_TYPES.PICKED_UP.label, color: { bg: '#f3e8ff', text: '#7c3aed' }, icon: User },
        [STATUS_TYPES.COMPLETED.key]: { label: STATUS_TYPES.COMPLETED.label, color: { bg: '#f3f4f6', text: '#6b7280' }, icon: Check },
        [STATUS_TYPES.CANCELLED.key]: { label: STATUS_TYPES.CANCELLED.label, color: { bg: '#fee2e2', text: '#dc2626' }, icon: Check },
        [STATUS_TYPES.REFUNDED.key]: { label: STATUS_TYPES.REFUNDED.label, color: { bg: '#fee2e2', text: '#dc2626' }, icon: RefreshCcw }
    };

    const config = STATUS_CONFIG[status];
    const Icon = config.icon;

    return (
        <StyledBadge
            bgColor={config.color.bg}
            textColor={config.color.text}
        >
            <Icon size={14} />
            {config.label}
        </StyledBadge>
    );
}

// Add hover effects
const StyledBadge = styled.span`
  display: inline-flex;
  align-items: center;
  gap: 4px;
  padding: 4px 12px;
  border-radius: 9999px;
  font-size: 0.875rem;
  font-weight: 500;
  background-color: ${props => props.bgColor};
  color: ${props => props.textColor};
  transition: all 0.2s ease;
  cursor: ${props => props.clickable ? 'pointer' : 'default'};
  
  &:hover {
    transform: ${props => props.clickable ? 'scale(1.05)' : 'none'};
  }
`;
